interface Period {
  firstDate: Date | string | number | null;
  lastDate: Date | string | number | null;
}

// Purpose: return an array with for each calendar month in the period an array item
// Example: period: 2023.01.04 - 2023.02.20
//          result: [ { firstDate: 2023.01.04, lastDate: 2023.01.31 } ], [ { firstDate: 2023.02.01, lastDate: 2023.02.20 } ]
//

export const datesToMonthlyPeriods = function (period: Period): Period[] {
  if (!period || !period.firstDate) {
    return [];
  }
  const start_date = new Date(period.firstDate);
  const end_date = period.lastDate ? new Date(period.lastDate) : new Date();

  const start_month = start_date.getMonth();
  const start_year = start_date.getFullYear();
  const end_month = end_date.getMonth();
  const end_year = end_date.getFullYear();

  if (start_month === end_month && start_year === end_year) {
    return [{ firstDate: start_date, lastDate: end_date }];
  }

  const periods: Period[] = [];

  const total_number_of_months =
    (end_year - start_year) * 12 + (end_month - start_month) + 1;

  if (total_number_of_months === 1) {
    return [{ firstDate: start_date, lastDate: end_date }];
  } else if (total_number_of_months === 2) {
    // the for loop will handle the 2 months case
    return [
      {
        firstDate: start_date,
        lastDate: new Date(start_year, start_month + 1, 0),
      },
      {
        firstDate: new Date(end_year, end_month, 1),
        lastDate: end_date,
      },
    ];
  }

  for (let i = 0; i < total_number_of_months; i++) {
    if (i === 0) {
      periods.push({
        firstDate: start_date,
        lastDate: new Date(start_year, start_month + 1, 0),
      });
    } else if (i === total_number_of_months - 1) {
      periods.push({
        firstDate: new Date(end_year, end_month, 1),
        lastDate: end_date,
      });
    } else {
      periods.push({
        firstDate: new Date(start_year, start_month + i, 1),
        lastDate: new Date(start_year, start_month + i + 1, 0),
      });
    }
  }

  return periods;
};
